<template>
  <v-container class="pa-0">
    <v-layout row class="pr-4">
      <span class="display-1 text-capitalize primary--text">Keep Your Calendar Updated</span>
    </v-layout>
    <v-divider></v-divider>
    <v-card class="my-4">
      <v-card-title class="grey lighten-4 py-0">
        <!-- <span class="title primary--text">
          Month: {{ pickerDate || 'change month...' }}
        </span> -->
        <v-spacer></v-spacer>
        <v-chip small color="secondary" text-color="white">
          {{busyDates.length}} Busy Days
        </v-chip>
        <v-btn color="primary" icon flat @click.native="editMode = true" v-show="!editMode">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn @click.native="editMode = false" v-show="editMode" color="primary" round outline>cancel</v-btn>
        <v-btn @click="saveUpdatedDates" v-show="editMode" color="primary" round :loading="loading" :disabled="loading">save</v-btn>
      </v-card-title>
      <v-card-text>
        <v-date-picker
          :color="!editMode? 'primary':'secondary'"
          ref="picker"
          class="my-3 elevation-0"
          v-model="date"
          :events="getDates"
          :event-color="date => trainingArray.indexOf(date) === -1 ? 'secondary' : 'orange lighten-1'"
          :picker-date.sync="pickerDate"
          :show-current="new Date().toISOString().substr(0, 10)"
          @input="busyDateToggle"
          full-width
          landscape
        ></v-date-picker>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
/* globals Store */
import { mapState } from 'vuex'
import { sendWarningNotice, closeNotice } from '@/utils/store-util.js'
export default {
  name: 'Calendar',
  data () {
    return {
      date: null,
      editMode: false,
      updateDates: {},
      pickerDate: null,
      trainingArray: []
    }
  },
  methods: {
    saveUpdatedDates () {
      const updateDates = this.updateDates
      const currentMonth = this.pickerDate
      Store.dispatch('calendar/updateCalendarDates', {updateDates, currentMonth})
      this.editMode = false
    },
    busyDateToggle (date) {
      if (!this.editMode) return
      if (new Date(date) < new Date().setDate(new Date().getDate() - 1)) {
        sendWarningNotice(null, 'Toggle not allowed on passed day')
        closeNotice(null, 1500)
      } else if (this.trainingArray.indexOf(date) !== -1) {
        sendWarningNotice(null, 'Toggle not allowed on training day')
        closeNotice(null, 1500)
      } else {
        console.log('editing the date')
        let index = this.updateDates[this.pickerDate].indexOf(date)
        if (index !== -1) {
          this.getDates.splice(index, 1)
        } else {
          this.getDates.push(date)
        }
      }
    }
  },
  computed: {
    getDates () {
      if (this.editMode) {
        return this.updateDates[this.pickerDate]
      } else {
        return this.busyDates
      }
    },
    ...mapState('calendar', {
      busyDates: 'busyDates',
      loading: 'loading'
    })
  },
  watch: {
    pickerDate (month) {
      if (this.editMode) {
        if (this.updateDates[month] === undefined) {
          Store.dispatch('calendar/getMonthData', {month,
            cb: (mon, val) => {
              this.updateDates[mon] = val
            }})
        }
      } else {
        Store.dispatch('calendar/getMonthData', {month})
      }
    },
    editMode (val) {
      if (val) {
        this.updateDates = {}
        console.log('picker date is:' + this.pickerDate)
        this.updateDates[this.pickerDate] = this.busyDates.slice(0)
      }
    }
  }
}
</script>
<style>
.v-date-picker-table > table > thead > tr > * {
  color: #009688 !important
}
</style>



// WEBPACK FOOTER //
// src/pages/Calendar.vue